import { locales, type Locale } from "./homepage-seo.ts";

export function localeFromPath(pathname: string): Locale | null {
  try {
    const first = decodeURIComponent(pathname.replace(/^\/+/, "").split("/")[0] || "");
    return (locales as readonly string[]).includes(first) ? first as Locale : null;
  } catch { return null; }
}

export function stripLocaleFromPath(pathname: string): string {
  const parts = pathname.replace(/^\/+/, "").split("/").filter(Boolean);
  return localeFromPath(pathname) ? `/${parts.slice(1).join("/")}` : pathname || "/";
}

/** Replace only the language prefix, never the active route, query or anchor. */
export function languageNavigationPath(
  location: { pathname: string; search: string; hash: string },
  nextLocale: Locale,
): string {
  const parts = location.pathname.split("/");
  let prefix = parts[1];
  try { prefix = decodeURIComponent(prefix || ""); } catch { /* Preserve an unknown path. */ }
  if ((locales as readonly string[]).includes(prefix)) parts.splice(1, 1);
  const route = parts.join("/") || "/";
  // The neutral offline shell represents Home, not a localized public route.
  const localizedRoute = route === "/offline-app" || route === "/offline-app.html" ? "/" : route;
  return `/${nextLocale}${localizedRoute}${location.search}${location.hash}`;
}
